"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const PaginatorPageDetails = ({ pageStart, pageEnd, totalEntries, pageTitle, entryName, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
        react_1.default.createElement(boxTitle_1.default, { title: pageTitle }),
        react_1.default.createElement(react_native_1.Text, null, `Showing ${pageStart} - ${pageEnd} of ${totalEntries} ${entryName}`)));
};
exports.default = PaginatorPageDetails;
